import React, { useContext, useState } from 'react';
import MaterialContext from '../context/material/materialContext';
import Modal from './Modal';
import Button from './Button';
import SupplierSiteList from './SupplierSiteList';

export default function SupplierSiteSelector({ proc, supplierId }) {
  const materialContext = useContext(MaterialContext);

  const { supplierSite, getSupplierSites } = materialContext;

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div style={selectorSytle}>
      {!supplierSite || supplierSite.name === 'undefined' ? (
        <Button
          className={`btn btn-${proc}`}
          text="Select Site"
          onClick={async () => {
            await getSupplierSites(supplierId);
            handleOpen();
          }}
        />
      ) : (
        <Button
          className={`btn btn-${proc}`}
          text={supplierSite.name}
          onClick={async () => {
            await getSupplierSites(supplierId);
            handleOpen();
          }}
        />
      )}
      <Modal 
        open={open}
        onClose={handleClose}
        component={<SupplierSiteList />} 
        proc="solid-bg-modal"
      />
    </div>
  );
}

const selectorSytle = {
  marginTop: '10px',
};
